import { commentItems } from '@/mocks/homepage';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          读者热议
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          百万吃瓜群众的热评，看看大家都在讨论什么
        </p>
        <div className="max-w-3xl mx-auto grid gap-5">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.author}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-thumb-up-line text-sm"></i>
                      </div>
                      {item.likes.toLocaleString()}
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-chat-1-line text-sm"></i>
                      </div>
                      回复
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-share-forward-line text-sm"></i>
                      </div>
                      分享
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}